import { Trans } from '@lingui/macro';
import * as React from 'react';
import { reach } from 'yup';
import { useFormValidator } from '../../../../../../../Form';
import { useGetFieldPath } from '../../../../../../context';

const IsNumberLessThanError = () => {
  const validationSchema = useFormValidator();
  const fieldPath = useGetFieldPath();
  const { max } = validationSchema ? reach(validationSchema, fieldPath).describe().meta : { max: null };
  return max ? (
    <Trans>
      Ce champ doit contenir une valeur inférieure ou égale à
      {' '}
      {max}
    </Trans>
  ) : null;
};

export const inputNumberLessThanErrorMessage = <IsNumberLessThanError />;
